"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_manager",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "approve",
        inputs: [
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "balanceOf",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "batchDepositTo",
        inputs: [
            {
                name: "round",
                type: "address",
                internalType: "address payable",
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "contractURI",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "createAndFundRoundOnExistingHouse",
        inputs: [
            {
                name: "house",
                type: "address",
                internalType: "address",
            },
            {
                name: "newRound",
                type: "tuple",
                internalType: "struct IPropHouse.Round",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                    {
                        name: "title",
                        type: "string",
                        internalType: "string",
                    },
                    {
                        name: "description",
                        type: "string",
                        internalType: "string",
                    },
                ],
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "createAndFundRoundOnNewHouse",
        inputs: [
            {
                name: "newHouse",
                type: "tuple",
                internalType: "struct IPropHouse.House",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                ],
            },
            {
                name: "newRound",
                type: "tuple",
                internalType: "struct IPropHouse.Round",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                    {
                        name: "title",
                        type: "string",
                        internalType: "string",
                    },
                    {
                        name: "description",
                        type: "string",
                        internalType: "string",
                    },
                ],
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "house",
                type: "address",
                internalType: "address",
            },
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "createHouse",
        inputs: [
            {
                name: "newHouse",
                type: "tuple",
                internalType: "struct IPropHouse.House",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "house",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "createRoundOnExistingHouse",
        inputs: [
            {
                name: "house",
                type: "address",
                internalType: "address",
            },
            {
                name: "newRound",
                type: "tuple",
                internalType: "struct IPropHouse.Round",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                    {
                        name: "title",
                        type: "string",
                        internalType: "string",
                    },
                    {
                        name: "description",
                        type: "string",
                        internalType: "string",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "createRoundOnNewHouse",
        inputs: [
            {
                name: "newHouse",
                type: "tuple",
                internalType: "struct IPropHouse.House",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                ],
            },
            {
                name: "newRound",
                type: "tuple",
                internalType: "struct IPropHouse.Round",
                components: [
                    {
                        name: "impl",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "config",
                        type: "bytes",
                        internalType: "bytes",
                    },
                    {
                        name: "title",
                        type: "string",
                        internalType: "string",
                    },
                    {
                        name: "description",
                        type: "string",
                        internalType: "string",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "house",
                type: "address",
                internalType: "address",
            },
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "depositTo",
        inputs: [
            {
                name: "round",
                type: "address",
                internalType: "address payable",
            },
            {
                name: "asset",
                type: "tuple",
                internalType: "struct Asset",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "exists",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getApproved",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "isApprovedForAll",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
            {
                name: "operator",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "isHouse",
        inputs: [
            {
                name: "house",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "isRound",
        inputs: [
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "manager",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IManager",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "name",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "ownerOf",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "safeTransferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "safeTransferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setApprovalForAll",
        inputs: [
            {
                name: "operator",
                type: "address",
                internalType: "address",
            },
            {
                name: "approved",
                type: "bool",
                internalType: "bool",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "supportsInterface",
        inputs: [
            {
                name: "interfaceId",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "pure",
    },
    {
        type: "function",
        name: "symbol",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "tokenURI",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "transferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                name: "owner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "approved",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                indexed: true,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                name: "owner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "operator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "approved",
                type: "bool",
                indexed: false,
                internalType: "bool",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "BatchDepositToRound",
        inputs: [
            {
                name: "from",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "round",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "assets",
                type: "tuple[]",
                indexed: false,
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "ContractURIUpdated",
        inputs: [
            {
                name: "uri",
                type: "string",
                indexed: false,
                internalType: "string",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "DepositToRound",
        inputs: [
            {
                name: "from",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "round",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "asset",
                type: "tuple",
                indexed: false,
                internalType: "struct Asset",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "HouseCreated",
        inputs: [
            {
                name: "creator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "house",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "kind",
                type: "bytes32",
                indexed: false,
                internalType: "bytes32",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoundCreated",
        inputs: [
            {
                name: "creator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "house",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "round",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "kind",
                type: "bytes32",
                indexed: false,
                internalType: "bytes32",
            },
            {
                name: "title",
                type: "string",
                indexed: false,
                internalType: "string",
            },
            {
                name: "description",
                type: "string",
                indexed: false,
                internalType: "string",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                name: "from",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                indexed: true,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "ADDRESS_ZERO",
        inputs: [],
    },
    {
        type: "error",
        name: "ALREADY_MINTED",
        inputs: [],
    },
    {
        type: "error",
        name: "ETHER_TRANSFER_FAILED",
        inputs: [],
    },
    {
        type: "error",
        name: "HOUSE_NOT_APPROVED_BY_USER",
        inputs: [],
    },
    {
        type: "error",
        name: "INSUFFICIENT_ETHER_SUPPLIED",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_APPROVAL",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_ASSET_TYPE",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_ERC721_TRANSFER_AMOUNT",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_HOUSE",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_HOUSE_IMPL",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_OWNER",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_RECIPIENT",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_ROUND",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_ROUND_IMPL_FOR_HOUSE",
        inputs: [],
    },
    {
        type: "error",
        name: "LENGTH_GTE_32",
        inputs: [],
    },
    {
        type: "error",
        name: "MISSING_ASSET_AMOUNT",
        inputs: [],
    },
    {
        type: "error",
        name: "NOT_MINTED",
        inputs: [],
    },
    {
        type: "error",
        name: "UNUSED_ASSET_PARAMETERS",
        inputs: [],
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class PropHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_manager, overrides) {
        return super.deploy(_manager, overrides || {});
    }
    getDeployTransaction(_manager, overrides) {
        return super.getDeployTransaction(_manager, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PropHouse__factory = PropHouse__factory;
PropHouse__factory.bytecode = _bytecode;
PropHouse__factory.abi = _abi;
